export default "__VITE_ASSET__jf4IVr7P__"